import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "../index.d";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import { IShopSettings } from "./index.d";
import { ShowAlert } from "../../utils/functions";

export default class ShopSettingsStore {
  shopSettings: IShopSettings = {} as IShopSettings;
  shopId: number = 1;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  getShopSettings = () => {
    const url = ApiConfig.REST_URIS.shopSettings.getShopSettings(this.shopId);
    Api.get(url, (res: ApiResponse<IShopSettings>) => {
      if (res?.isSuccess && res.data) {
        this.shopSettings = res.data;
      }
    });
  };

  updateShopSettings = (settings: IShopSettings) => {
    const url = ApiConfig.REST_URIS.shopSettings.updateShopSettings(
      this.shopId
    );
    settings.shopId = this.shopId;
    Api.post(url, settings, (res: ApiResponse<boolean>) => {
      if (res?.isSuccess && res.data) {
        ShowAlert.Success("Shop settings updated.");
      } else {
        ShowAlert.Error("Request failed. Please try again.");
      }
    });
  };
}
